var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.editStore.notFound
    ? _c("NotFound")
    : _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.editStore.isLoading,
            failed: _vm.editStore.hasLoadingFailed,
          },
          on: { retry: _vm.editStore.load },
        },
        [
          _c("PastProjectForm", {
            attrs: {
              loading: _vm.editStore.isUpdating,
              destroying: _vm.destroyStore.isLoading,
              errors: _vm.editStore.formErrors,
              values: _vm.editStore.data,
              allowDestroy: "",
            },
            on: { submit: _vm.submit, destroy: _vm.destroy },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }